module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/trips/trips-list/trips-list.component.css
// module id = ./src/app/trips/trips-list/trips-list.component.css
// module chunks = main